import { Decimal, parseDecimal } from '@insio/decimal';
import type { InvoiceLine } from '../../../../graphql/generated/graphql';

/** Field names that hold a string value (not a numeric/Decimal one). */
const TEXT_FIELDS = new Set<keyof InvoiceLine>(['description', 'unit', 'code', 'ean', 'vatMode']);

/** Return a new line with `field` updated to `value`.
 *
 * Field-type discrimination:
 * - `null` clears the field (used when the VAT-rate selector is cleared).
 * - Free-text fields (`description`, `unit`, `code`, `ean`) keep `value` as a string.
 * - A `Decimal` `value` is committed as-is (used by the VAT-rate selector and
 *   by the "apply expected value" affordance on total inputs).
 * - Anything else is parsed as a locale-tolerant decimal (empty/invalid → null).
 */
export function updateLineField(
  line: Partial<InvoiceLine>,
  field: keyof InvoiceLine,
  value: string | Decimal | null
): Partial<InvoiceLine> {
  if (value === null) {
    return { ...line, [field]: null };
  }
  if (TEXT_FIELDS.has(field)) {
    return { ...line, [field]: value };
  }
  if (value instanceof Decimal) {
    return { ...line, [field]: value };
  }
  return { ...line, [field]: parseDecimal(value) };
}
